export const deputation_details = `{
	id
  lang
  title
  description
  country_id
  state_id
  city_id
  address
  postal_code
  media {
    url
    alt
  }
  location
  label
  phone
  color
  state {
    id
    name
    native
  }
}`;

export const deputations = `{
  id
  title
  location
  address
  phone
  description
  city {
      id
      name
      native
  }
  state {
      id
      name
      native
  }
  country {
      id
      name
      native
  }
}`;
export const shipping_center = `{
  id
  title
  location
  address
  phone
  description
  estimate_time
  city {
      id
      name
      native
  }
  state {
      id
      name
      native
  }
  country {
      id
      name
      native
  }
}`;
